package gr.tech.meetinggenie.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.meetinggenie.models.meeting.ActiveProjectDTO
import gr.tech.meetinggenie.models.meeting.DealStage
import gr.tech.meetinggenie.models.meeting.ProjectNeed
import gr.tech.meetinggenie.styles.*
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLSelectElement

@Composable
fun ActiveProjectsTableInput(
    activeProjects: List<ActiveProjectDTO>,
    onUpdate: (List<ActiveProjectDTO>) -> Unit,
) {
    DraggableDataTable(
        rowCount      = activeProjects.size,
        onMove        = { from, to -> onUpdate(activeProjects.toMutableList().also { it.add(to, it.removeAt(from)) }) },
        onDelete      = { index   -> onUpdate(activeProjects.toMutableList().also { it.removeAt(index) }) },
        maxRows       = 3,
        addButtonText = "Add Project",
        onAdd         = { onUpdate(activeProjects + ActiveProjectDTO()) },
        headers = {
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(160.px).toAttrs()) { Text("Project / Account Name") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(130.px).toAttrs()) { Text("Deal Stage") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(160.px).toAttrs()) { Text("Biggest Blocker") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(190.px).toAttrs()) { Text("What do you need?") }
        },
        rowCells = { index ->
            val project = activeProjects[index]

            // Project / Account Name
            Td(DataEntryCellStyle.toModifier().minWidth(160.px).padding(0.px).toAttrs()) {
                autoResizeTextArea(
                    value   = project.projectName,
                    onInput = { v -> onUpdate(activeProjects.toMutableList().also { it[index] = it[index].copy(projectName = v) }) }
                )
            }

            // Deal Stage — dropdown
            Td(DataEntryCellStyle.toModifier().minWidth(130.px).padding(4.px).toAttrs()) {
                Select(
                    attrs = TableSelectStyle.toModifier().toAttrs {
                        onChange { event ->
                            val name = (event.target as HTMLSelectElement).value
                            val stage = DealStage.entries.firstOrNull { it.name == name }
                            onUpdate(activeProjects.toMutableList().also { it[index] = it[index].copy(dealStage = stage) })
                        }
                    }
                ) {
                    Option("", attrs = { if (project.dealStage == null) selected() }) { Text("— select —") }
                    DealStage.entries.forEach { stage ->
                        Option(stage.name, attrs = { if (project.dealStage == stage) selected() }) {
                            Text(stage.label)
                        }
                    }
                }
            }

            // Biggest Blocker
            Td(DataEntryCellStyle.toModifier().minWidth(160.px).padding(0.px).toAttrs()) {
                autoResizeTextArea(
                    value   = project.biggestBlocker,
                    onInput = { v -> onUpdate(activeProjects.toMutableList().also { it[index] = it[index].copy(biggestBlocker = v) }) }
                )
            }

            // What do you need? — checkboxes (multi-select)
            Td(DataEntryCellStyle.toModifier().minWidth(190.px).padding(4.px).toAttrs()) {
                Column(verticalArrangement = Arrangement.spacedBy(4.px)) {
                    ProjectNeed.entries.forEach { option ->
                        Label(attrs = CheckboxOptionLabelStyle.toModifier().toAttrs()) {
                            Input(
                                type = InputType.Checkbox,
                                attrs = CheckboxInputStyle.toModifier().toAttrs {
                                    checked(project.needs.contains(option))
                                    onClick {
                                        val newNeeds = if (project.needs.contains(option))
                                            project.needs.filter { it != option }
                                        else
                                            project.needs + option
                                        onUpdate(activeProjects.toMutableList().also { it[index] = it[index].copy(needs = newNeeds) })
                                    }
                                }
                            )
                            Text(option.label)
                        }
                    }
                }
            }
        }
    )
}
